import React from 'react'
import { memorandumTopic } from '../../../../../../constants/constants'
import constUserGroup from '../../../../../../constants/userGroup'

import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useManageProjectAction from '../../../../../../stores/manageProject/useManageProjectAction'

import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'

import checkPermission from '../../../../../../utilities/checkPermission'
import useLoading from '../../../../../../control/loading/useLoading'
import useWebService from '../../../../../../services/web/useWebService'
import { SignREC1Type } from './signREC1'
import { DialogType } from '../../../../../../control/dialog/dialog'
import authenStore from '../../../../../../stores/authen/authenStore'
import * as REQServiceType from '../../../../../../services/web/types/requestWebServiceTypes'
import useTranslate from '../../../../../../i18n/useTranslate'
import SecretCodeForm from '../../../../shareUI/secretCodeForm/secretCodeForm'
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../../../../router/routesConfig'
import { UploadFileObjCerType } from '../../generateCertificate/generateCertificateType'
import { encryption } from '../../../../../../utilities/encryption'
import { MemoMessagePaperType } from '../../../../../../services/web/types/responseWebServiceTypes'
type CerDialogType = Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>
const useSignREC1 = (props: SignREC1Type) => {
    const translate = useTranslate()
    const { callbackSaveComplete } = props
    const checkPermissionHook = checkPermission()
    const loadingHook = useLoading()
    const callWebService = useWebService()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const manageProjectStore = useManageProjectStore()
    const { projectData } = manageProjectStore
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const history = useHistory()
    const [isNotShowSign, setIsNotShowSign] = React.useState<boolean>(false)

    const statusAfterClose = React.useRef<string>('save')

    const appFolderAndTabStore = useAppFolderAndTabStore()
    const { tabSelected } = appFolderAndTabStore
    const profileStore = authenStore()
    const { profile } = profileStore

    const [initialValues, setInitialValues] = React.useState<any>({})
    const [configDialog, setConfigDialog] = React.useState<CerDialogType>()
    const [initialMemorandumFile, setInitialMemorandumFile] = React.useState<any>()
    const [initialMemorandumFileSign, setInitialMemorandumFileSign] = React.useState<any>()

    const dialogRef = React.useRef<Record<string, Function>>()

    React.useEffect(() => {
        createInitialFileMemorandum()
    }, [])
    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }
    const createInitialFileMemorandum = async () => {
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null
        if (submittedID) {
            const res = await callWebService.getProjectTerminateMemoMessage(submittedID)
            const result = res.result

            const memorandumInfo = result.memoMessagePaperInfo
            const uploadFileMemoranduminit: Array<UploadFileObjCerType> = memorandumTopic?.map(
                (itm: any, idx: number) => {
                    return {
                        uploadFileObj: {
                            fileList: [],
                            subTopicPageList: [],
                            documentTopicID: itm.id,
                        },
                    }
                },
            )
            uploadFileMemoranduminit.forEach((itm: UploadFileObjCerType) => {
                if (itm.uploadFileObj.documentTopicID === 0) {
                    if (memorandumInfo?.name_th) {
                        let fileListTH = {
                            documentTopicID: 0,
                            fileToken: memorandumInfo?.name_th,
                            filename: memorandumInfo?.name_th,
                            fileID: memorandumInfo?.name_th,
                            path: memorandumInfo?.unSignPathInfo?.path_th,
                        }
                        //@ts-ignore
                        itm.uploadFileObj.fileList.push(fileListTH)
                    }
                } else if (itm.uploadFileObj.documentTopicID === 1) {
                    if (memorandumInfo?.name_en) {
                        let fileListEN = {
                            documentTopicID: 1,
                            fileToken: memorandumInfo?.name_en,
                            filename: memorandumInfo?.name_en,
                            fileID: memorandumInfo?.name_en,
                            path: memorandumInfo?.unSignPathInfo?.path_en,
                        }
                        //@ts-ignore
                        itm.uploadFileObj.fileList.push(fileListEN)
                    }
                }

                itm.uploadFileObj.subTopicPageList = []
            })

            const initialMemorandumFile = createInitialFileData(memorandumInfo)
            setInitialMemorandumFileSign(initialMemorandumFile)
            setInitialMemorandumFile(uploadFileMemoranduminit)
        }
    }

    const createInitialFileData = (memoMessagePaperInfo: MemoMessagePaperType) => {
        const uploadFileMemoranduminit: Array<UploadFileObjCerType> = memorandumTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        uploadFileMemoranduminit.forEach((itm: UploadFileObjCerType) => {
            if (itm.uploadFileObj.documentTopicID === 0) {
                if (memoMessagePaperInfo?.certificateSignFileName_th) {
                    let fileListTH = {
                        documentTopicID: 0,
                        fileToken: memoMessagePaperInfo?.certificateSignFileName_th,
                        filename: memoMessagePaperInfo?.certificateSignFileName_th,
                        fileID: memoMessagePaperInfo?.certificateSignFileName_th,
                        path: memoMessagePaperInfo?.cerSign_th,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListTH)
                }
            } else if (itm.uploadFileObj.documentTopicID === 1) {
                if (memoMessagePaperInfo?.certificateSignFileName_en) {
                    let fileListEN = {
                        documentTopicID: 1,
                        fileToken: memoMessagePaperInfo?.certificateSignFileName_en,
                        filename: memoMessagePaperInfo?.certificateSignFileName_en,
                        fileID: memoMessagePaperInfo?.certificateSignFileName_en,
                        path: memoMessagePaperInfo?.cerSign_en,
                    }
                    //@ts-ignore
                    itm.uploadFileObj.fileList.push(fileListEN)
                }
            }

            itm.uploadFileObj.subTopicPageList = []
        })
        return uploadFileMemoranduminit
    }

    const handleDirtyChange = (props: { dirty: boolean }) => {
        appFolderAndTabAction.setTabDirty(props.dirty)
    }
    const handleSubmitForm = async (val: any) => {
        const signCertificateRequest: REQServiceType.SignMemomessageType = {
            projectID: projectData?.projectID || null,
            signUserID: profileStore.profile.userId,
            submittedID: projectData?.submittedID || null,
            isSignBehalfSecretary: false,
            // isSignBehalfSecretary: false,
            signUserPinCode: null,
        }
        if (val.saveType === 'SAVE') {
            setConfigDialog({
                title: translate.get('LABEL.SECRET_PASSWORD'),
                content: React.createElement(SecretCodeForm, {
                    onClickClose: () => {
                        dialogRef.current?.closeDialog()
                    },
                    onClickSave: (val: any) => {
                        handleSubmitSecretCode({
                            ...signCertificateRequest,
                            signUserPinCode: encryption(val.password),
                        })
                    },
                }),
                type: '',
            })
            dialogRef.current?.openDialog()
        }
    }
    const handleSubmitSecretCode = async (paramForSave: any) => {
        dialogRef.current?.closeDialog()
        loadingHook.loadingOpen()
        const res = await callWebService.signMemomessage(paramForSave)
        if (callbackSaveComplete) {
            if (res && res.status) {
                callbackSaveComplete(res.status, false)
            }
        }
        loadingHook.loadingClose()
        // await conditionDialog(res?.status)
    }
    // const conditionDialog = (status: number) => {
    //     if (status === 1) {
    //         setConfigDialog({
    //             title: translate.get('ALERT.TITLE.NOTIFICATION'),
    //             content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
    //             type: 'alert-message',
    //             onAfterClose: handleAfterClose,
    //         })
    //         dialogRef.current?.openDialog()
    //     } else if (status === -2) {
    //         setConfigDialog({
    //             title: translate.get('ALERT.TITLE.WARNING'),
    //             content: translate.get('ALERT.CONTENT.SECRET_PASSWORD_INCORRECT'),
    //             type: 'alert-message',
    //         })
    //         dialogRef.current?.openDialog()
    //     } else {
    //         setConfigDialog({
    //             title: translate.get('ALERT.TITLE.ERROR'),
    //             content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
    //             type: 'alert-message',
    //         })
    //         dialogRef.current?.openDialog()
    //     }
    // }
    // const handleAfterClose = () => {
    //     const { userGroupId } = profile
    //     if (statusAfterClose.current === 'save') {
    //         switch (userGroupId) {
    //             case userGroup.presidentIRB1.groupId:
    //             case userGroup.secretaryIRB1.groupId:
    //             case userGroup.presidentIRB2.groupId:
    //             case userGroup.secretaryIRB2.groupId:
    //             case userGroup.vicePresident.groupId:
    //                 if (
    //                     tabSelected.id === menuTab.tab2Chairman.id ||
    //                     tabSelected.id === menuTab.tab6Chairman.id ||
    //                     tabSelected.id === menuTab.tab9.id
    //                 ) {
    //                     history.push(RoutePath.manageProject)
    //                 } else {
    //                     setDefaultPage()
    //                 }
    //                 break
    //             case userGroup.committee.groupId:
    //                 if (tabSelected.id === menuTab.tab5Commitee.id) {
    //                     history.push(RoutePath.manageProject)
    //                 }
    //                 break

    //             default:
    //                 setDefaultPage()
    //                 break
    //         }
    //     } else {
    //         setDefaultPage()
    //     }
    // }
    // const setDefaultPage = () => {
    //     setConfigDialog({}) //clear function dialog
    //     // loadLatestFolder()
    //     appFolderAndTabAction.resetTabDirty()
    // }

    const chkBtnSing = async (projectID: number, submittedID: number) => {
        if (projectID && submittedID) {
            const { result, status } = await callWebService.getSignCertificate(projectID, submittedID)

            if (status === 1) {
                if (
                    profile.userGroupId === constUserGroup.president ||
                    profile.userGroupId === constUserGroup.reviewer
                ) {
                    setIsNotShowSign(result.isSignBeHalfPresident)
                } else if (profile.userGroupId === constUserGroup.secretary) {
                    setIsNotShowSign(result.isSignBeHalfSecretary)
                }
            }
        }
    }
    const handleClickBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }
    return {
        onRefDialog,
        configDialog,

        isViewMode,
        isNotShowSign,

        initialValues,
        initialMemorandumFile,
        initialMemorandumFileSign,
        projectData,
        handleDirtyChange,
        onSubmitForm: handleSubmitForm,
        onClickBackToSearch: handleClickBackToSearch,
    }
}
export default useSignREC1
